import React from 'react';
import cn from 'classnames';
import './index.css';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../components';
import HistorySvg from './History-svg';

const {
  dateFormat,
  paymentMethodFormatter,
  priceFormat,
} = require('@cashew/utils');

const currencyCode = 'AED';
const ns = 'payment-option-item';
export default ({ data, setSelectedOption, setPaymentHistoryModal }: any) => {
  const {
    subProductType,
    orderCashewFee,
    serviceFeePercentage,
    startDate,
    max,
    min,
  } = data;
  const { t } = useTranslation();
  const { text, numbers } = paymentMethodFormatter(subProductType);
  return (
    <div className={cn(ns)}>
      <div className={`${ns}__store`}>
        {t(`product.${text}`, { number: numbers, x: numbers })}
      </div>
      <div className={`${ns}__store`}>
        {priceFormat({
          currency: currencyCode,
          amount: orderCashewFee,
        })}
      </div>
      <div className={`${ns}__store`}>{`${serviceFeePercentage}%`}</div>
      <div className={`${ns}__store`}>
        {!startDate ? '' : dateFormat({ date: startDate })}
      </div>
      <div className={`${ns}__store`}>
        {priceFormat({
          currency: currencyCode,
          amount: max,
        })}
      </div>
      <div className={`${ns}__store`}>
        {priceFormat({
          currency: currencyCode,
          amount: min,
        })}
      </div>
      <div>
        <Button
          onClick={() => {
            setSelectedOption(subProductType);
            setPaymentHistoryModal(true);
          }}
        >
          <HistorySvg />
        </Button>
      </div>
    </div>
  );
};
